import { combineReducers } from "redux";
import userInfo from "./userInfo";
import config from "./config";

export default combineReducers({ userInfo, config });
